<template>
  <SearchedUserSecondary
    :tenantUser="expert"
    :tenantUserSkills="expert.tenantUserSkills"
  >
    <template v-slot:custom-container>
      <div :style="style.container">
        <ButtonTextMuted
          v-if="expert.isTenantTeamTenantUser"
          @click="deleteTenantUserFromTenantTeam(expert)"
        >
          Remove from team
        </ButtonTextMuted>
        <ButtonTextPrimary
          v-else
          @click="addTenantUserToTenantTeam(expert)"
        >
          Add to team
        </ButtonTextPrimary>
      </div>
    </template>
  </SearchedUserSecondary>
</template>

<script>
  import ButtonTextMuted from '@modules/button/button-text-muted'
  import ButtonTextPrimary from '@modules/button/button-text-primary'
  import SearchedUserSecondary from '@modules/search/searched-user-secondary'
  import { Layout } from '@js/styles'

  export default {
    name: 'SearchedUserVertical',
    components: {
      ButtonTextMuted,
      ButtonTextPrimary,
      SearchedUserSecondary,
    },
    props: {
      expert: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          container: {
            display: 'flex',
            height: Layout.space.md,
            margin: `0 0 0 ${Layout.space.xs}`,
            width: '100%',
          },
        },
      };
    },
    methods: {
      addTenantUserToTenantTeam: function (expert) {
        const tenantUserId = expert.id;
        this.$emit('add-to-team', tenantUserId);
      },
      deleteTenantUserFromTenantTeam: function (expert) {
        this.$emit('delete-from-team', expert.tenantTeamTenantUserId);
      },
    },
  };
</script>
